import { getSessionId } from "@/lib/booking/analytics";

// SonsHub CAPI attribution endpoint.
const CAPI_ATTRIBUTION_URL =
  "https://jhgvpqnesquocndbzygl.supabase.co/functions/v1/capi-attribution";

function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(
    new RegExp("(?:^|; )" + name + "=([^;]*)"),
  );
  return m ? decodeURIComponent(m[1]) : null;
}

export function captureFbclid(): void {
  try {
    if (typeof window === "undefined") return;
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid) {
      window.sessionStorage.setItem("fbclid", fbclid);
      window.sessionStorage.setItem("fbclid_ts", String(Date.now()));
    }
  } catch {
    /* ignore */
  }
}

function getMetaIds(): { fbp: string | null; fbc: string | null } {
  const fbp = getCookie("_fbp");
  let fbc = getCookie("_fbc");
  if (!fbc && typeof window !== "undefined") {
    try {
      const fbclid = window.sessionStorage.getItem("fbclid");
      const ts = window.sessionStorage.getItem("fbclid_ts");
      if (fbclid) fbc = `fb.1.${ts || Date.now()}.${fbclid}`;
    } catch {
      /* ignore */
    }
  }
  return { fbp, fbc };
}

export function sendCapiAttribution(): void {
  try {
    const { fbp, fbc } = getMetaIds();
    if (!fbp && !fbc) return;
    const session_id = getSessionId();
    if (!session_id) return;
    void fetch(CAPI_ATTRIBUTION_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id, fbp, fbc }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* best-effort; never surface to the customer */
  }
}